export default __webpack_public_path__ + "static/media/open-finance.2e13d0c2.png";